export default "__VITE_ASSET__DmClHLRX__"